import {
  buildStudentRoadmap,
  getCompletedRoadmapStages,
  getRoadmapSummary,
} from '../../student-roadmap.js'

export function buildLearningProgress(plan) {
  const roadmap = buildStudentRoadmap(plan)
  const completedStageIds = getCompletedRoadmapStages(plan)
  const summary = getRoadmapSummary(roadmap, completedStageIds)

  return {
    completedStageIds,
    currentStage: summary.current,
    currentStep: summary.currentStep,
    roadmap,
    summary,
  }
}

export function learningStageRoute(stage) {
  const step = stage?.steps?.find((item) => !item.completed) || stage?.steps?.[0]
  if (!step?.id) return '/learning'
  return stage?.templateLabel === 'AI 专属路线'
    ? `/learning/ai/${encodeURIComponent(step.id)}`
    : `/learning/${encodeURIComponent(step.id)}`
}
